import DeliveryAccept from "../symbols/deliveryAccept";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

function DeliveryAcceptReducer(state = initialState, action: any) {
  switch (action.type) {
    case DeliveryAccept.DELIVERY_ACCEPT:
      return { ...state, loading: true, error: false };
    case DeliveryAccept.DELIVERY_ACCEPT_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case DeliveryAccept.DELIVERY_ACCEPT_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case DeliveryAccept.CLEAR_DELIVERY_ACCEPT:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
export default DeliveryAcceptReducer;
